
export default {
  name: 'BirthdayCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "How can I calculate my birthday day?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Calculating birthdays has become a lot easier since the birth of birthday calculators. But if you want to calculate it manually, you must subtract the current and present age."
        }
      },{
        "@type": "Question",
        "name": "What is my today's date if I was born in 2007?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The answer is 15 years old. It is the result of the calculation 2022 - 2007 = 15."
        }
      },{
        "@type": "Question",
        "name": "Is there a rare birthday?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The truth is yes. Some rare birthdays include New Year, Christmas, Halloween, July 4, and Thanksgiving."
        }
      },{
        "@type": "Question",
        "name": "Does birth month affect success?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Many believe that birth month significantly influences a person's health, the success rate at work, study, and lifestyle. An excellent example of a health condition is that children in school often have more days, especially in extreme weather conditions."
        }
      },{
        "@type": "Question",
        "name": "How can you find out someone's age?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Checking public profiles and data is the fastest way to know a person's age. You can visit some websites like Intelius, enter your name and location, and the results are ready. Some other methods are also instrumental, such as: Asking their relatives, parents, and friends. Using the internet. Check out LinkedIn."
        }
      }]
    };
  },
  head() {
  	return {
  		link: [
  			{ rel: 'stylesheet', href: '/assets/css/vendors.min.css' }
  		]
  	}
  },
  mounted: function () {
    new Litepicker({
		element: document.getElementById('datepicker-birthday'),
		startDate: new Date(),
		buttonText: {
			previousMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="15 6 9 12 15 18" /></svg>`,
			nextMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="9 6 15 12 9 18" /></svg>`,
		}
    });
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        birthday: ''
      })
    }
  },
  methods: {
    onBirthdayCalculator() {
		this.form.birthday = jQuery('#datepicker-birthday').val();
        this.form.post(`/tool/birthday-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
